import { AccountType, ReferralSourceEnum } from '../user';

export interface CreateUserRequest {
  password?: string;
  groupName: string;
  referralSource?: ReferralSourceEnum;
  isMarketingAccepted: boolean;
  referrerUserId?: string;
  affiliateClickId?: string;
  parent?: string;
  accountType?: AccountType;
  username?: string;
}
